import React from 'react';
import Icon from 'components/general/Icon/Icon';

const networks = (title, href) => ([
  {
    name: 'Twitter',
    icon: 'twitter',
    url: `https://twitter.com/home?status=${encodeURIComponent(href)}`,
  },
  {
    name: 'Linkedin',
    icon: 'linkedin',
    url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(href)}&title=${encodeURIComponent(title)}`,
  },
  {
    name: 'Facebook',
    icon: 'facebook',
    url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(href)}`,
  },
]);

const Share: React.SFC<PropDef> = ({ title, url }) => (
  <ul className="share">
    {networks(title, url).map(network => (
      <li className="share__item" key={`share-${network.name}`}>
        <a
          href={network.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon name={network.icon} type="solid" />
        </a>
      </li>
    ))}
  </ul>
);

interface PropDef {
  title: string;
  url: string;
}

export default Share;

